import screenshotSrc from "../../../assets/images/integrations/create-offer.png";
import { ExtraFeature } from "../../common/IntegrationDetail";
import Screenshot from "../../common/Screenshot";

const targetedIncentives = (title: string): ExtraFeature => ({
  headline: "Create targeted incentives to prevent churn",
  description: `Automate your retention efforts with targeted offers and incentives. Start preventing churn immediately with a customized cancellation flow powered by your ${title} account — with minimal dev time required.`,
  image: (
    <>
      <Screenshot
        src={screenshotSrc}
        alt=""
        width={576.5}
        height={400}
        style={{ width: "100%", maxWidth: "530px" }}
      />
    </>
  ),
});

export default targetedIncentives;
